import React from "react";
import { useSelector } from "react-redux";
import BaseTextField from '../../Base/ui/inputs/TextField'

const SsnField = () => {
  const props = useSelector((state) => {
    return {
      ssn: state.resident.ssn,
      show_ssn: state.resident.show_ssn,
    }
  });

  const hideSsn = () => {
    if(props.ssn) return props.ssn.replace(/.(?=.{4,}$)/g, '*');
  }

  return props.show_ssn && (
    <BaseTextField 
      label={"Social Security Number"}
      value={hideSsn()}
      action={"show"}/>
  )
};

export default SsnField;
